import Base64Support from '~/helpers/base64/Base64Support';

export default class BrowserBase64Support extends Base64Support {
  encode(value: string): string {
    return window.btoa(value);
  }

  decode(value: string): string {
    return window.atob(value);
  }
}
